<script>
  import Slick from 'vue-slick'
  import 'slick-carousel/slick/slick.css'
  import { nlToBr } from '@utils/index'
  export default {
    components: {  Slick },
    props: {
      aboutCompany: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        list: [
          {
            icon: 'icon1',
            title: '成立最久的IT加值整合代理商'
          },
          {
            icon: 'icon2',
            title: '專注加值服務之經銷夥伴超過1000家'
          },
          {
            icon: 'icon3',
            title: '業界最專業傑出的產品經理團隊'
          },
          {
            icon: 'icon4',
            title: '擁有最完整的產品解決方案</br>設備完善的教育訓練中心'
          },
          {
            icon: 'icon5',
            title: '專業顧問規劃服務及技術支援服務'
          },
          {
            icon: 'icon6',
            title: '創新行銷服務平台'
          }
        ],
        swiperAdvantageOption: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // centerMode: true,
          dots: true,
          rows: 2,
          arrows: false,
        }
      }
    },
    methods: {
      nlToBr(item) {
        return nlToBr(item)
      }
    }
  }
</script>
<template>
  <section :class="$style.scetionAdvantage" class="bg-fix">
    <div class="container section bg-overly ">
      <BaseSectionTitle title="競爭優勢" class="text-center"/>
      <div v-if="!!aboutCompany.compete.length" class="row scetionAdvantage__list d-md-flex d-none">
        <div
          v-for="(item, $index) in aboutCompany.compete" :key="$index"
          class="col-12 col-md-6 col-lg-4 text-center"
        >
          <div class="bg-white scetionAdvantage__item">
            <div class="text-primary icon">
              <img :src="item.icon || require(`@src/assets/images/about/icon1.png`)" alt="">
            </div>
            <p class="mt-4 mb-0"  v-html="nlToBr(item.description) || ''"></p>
          </div>
        </div>
      </div>
      <Slick
        v-if="!!aboutCompany.compete.length"
        ref="carouselAdvantage"
        :options="swiperAdvantageOption"
        class="scetionAdvantage__list d-md-none"
      >
        <div
          v-for="(item, $index) in aboutCompany.compete"
          :key="$index"
          class="text-center"
        >
          <div class="bg-white scetionAdvantage__item">
            <div class="text-primary icon">
              <img :src="item.icon || require(`@src/assets/images/about/icon1.png`)" alt="">
            </div>
            <p class="mt-4 mb-0" v-html="nlToBr(item.description) || ''"></p>
          </div>
        </div>
      </Slick>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
  </section>
</template>
<style lang="scss" module>
  .scetionAdvantage {
    background: $color-gray-2;
    @include max-md {
      padding-bottom: 3rem;
    }
    :global {
      .scetionAdvantage {
        &__list {
          @include max-md {
            
          //   margin-right: -0.5rem;
          //   margin-left: -0.5rem;
          //   & > div {
          //     padding-right: 0.5rem;
          //     padding-left: 0.5rem;
          //   }
          }

        }

        &__item {
          height: 224px;
          padding: 46px 0.5rem;
          margin-top: 60px;
          border-radius: 2px;
          box-shadow: 0 2px 4px rgba(33, 69, 88, 0.16);

          @include max-md {
            margin-top: 1rem;
            box-shadow: none;
          }

          .icon {
            font-size: 3rem;
          }
          img {
            @include max-md {
              margin: 0 auto;
            }
          }
        }
      }
      .slick-dots {
        @include list-unstyled;

        position: absolute;
        bottom: -2rem;
        left: 50%;
        display: flex;
        justify-content: center;
        margin-bottom: 0;
        transform: translateX(-50%);

        li {
          padding: 0 0.5rem;

          button {
            display: block;
            width: 10px;
            height: 10px;
            padding: 0;
            font-size: 0;
            background: #B1BACB;
            border: none;
            border-radius: 15px;
            transition: width 0.3s;
            appearance: none;
          }

          &.slick-active {
            button {
              width: 47px;
              background: $color-primary;
            }
          }
        }
      }
    }
  }
</style>
